module.exports = ["Vbelt",
    "timingTimingBelt",
    "polyV-belt",
    "conveyorBandBelt"]